module.exports = __webpack_public_path__ + "static/media/friendship.342a0085.svg";